import { Accordion } from '@components/';
import { formatDateBR } from '../../hooks';
import {
  mapClassificacaoTroca,
  mapPlataforma,
  mapRetira,
  mapStatusIntegracao,
  mapAvaliacaoCredito,
  mapTipoRegistro,
  mapTipoEnvio,
} from '../../utils/fieldMappings';
import type { SelectedProduct } from './interfaces';

interface OrderSummaryProps {
  orderData: {
    estabelecimento: string;
    tipoEnvio?: string;
    pedidoInterno: string;
    classificacaoTroca?: string;
    avaliacaoCredito?: string;
    plataforma?: string;
    retira?: string;
    numeroParcelas?: number;
    ecomPj?: boolean;
    statusIntegracao: string;
    tipoRegistro: string;
    dataEntrega?: string;
    dataIntegracao?: string; // Tornar opcional
    observacoes?: string;
    evidenciaMotivo?: string;
  };
  products: SelectedProduct[];
}

export function OrderSummary({ orderData, products }: OrderSummaryProps) {
  if (!orderData) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>Dados do pedido não encontrados</p>
      </div>
    );
  }

  // Construir dados para o Accordion com mapeamentos aplicados
  const fieldsData = [
    { label: "Estabelecimento", value: orderData.estabelecimento || '-' },
    { label: "Tipo de Envio", value: orderData.tipoEnvio ? mapTipoEnvio(orderData.tipoEnvio) : '-' },
    { label: "Pedido Interno", value: orderData.pedidoInterno || '-' },
    { label: "Classificação da Troca", value: orderData.classificacaoTroca ? mapClassificacaoTroca(orderData.classificacaoTroca) : '-' },
    { label: "Avaliação de Crédito", value: orderData.avaliacaoCredito ? mapAvaliacaoCredito(orderData.avaliacaoCredito) : '-' },
    { label: "Plataforma", value: orderData.plataforma ? mapPlataforma(orderData.plataforma) : '-' },
    { label: "Retira", value: orderData.retira ? mapRetira(orderData.retira) : '-' },
    { label: "Número de Parcelas", value: orderData.numeroParcelas?.toString() || '0' },
    { label: "ECOM PJ", value: orderData.ecomPj ? "Sim" : "Não" },
    { label: "Status da Integração", value: orderData.statusIntegracao ? mapStatusIntegracao(orderData.statusIntegracao) : '-' },
    { label: "Tipo do Registro", value: orderData.tipoRegistro ? mapTipoRegistro(orderData.tipoRegistro) : '-' },
    { label: "Data de Entrega", value: orderData.dataEntrega ? formatDateBR(orderData.dataEntrega) : '-' },
    { label: "Data da Integração", value: orderData.dataIntegracao ? formatDateBR(orderData.dataIntegracao) : '-' },
    ...(orderData.observacoes ? [{ label: "Observações", value: orderData.observacoes }] : []),
    ...(orderData.evidenciaMotivo ? [{ label: "Evidência do Motivo", value: orderData.evidenciaMotivo }] : []),
  ];

  const fields = fieldsData.map(field => field.label);
  const values = fieldsData.map(field => field.value);

  return (
    <div className="flex flex-col gap-4">
      <Accordion
        title={`Pedido ${orderData.pedidoInterno}`}
        fields={fields}
        values={values}
        defaultOpen={true}
      />
      
      {products.length > 0 && (
        <div className="space-y-2">
          {products.map((product) => (
            <Accordion
              key={product.id}
              title={`${product.name}`}
              fields={[
                "Nome",
                "Código do produto",
                "Marca",
                "Linha",
                "Família do produto",
                "Código ERP",
                "Ativo",
                "Peso",
                "Altura",
                "Largura",
                "Profundidade",
                "Quantidade",
                "Preço"
              ]}
              values={[
                product.name,
                String(product.custom_object_fields?.codigo_do_produto || '-'),
                String(product.custom_object_fields?.marca || '-'),
                String(product.custom_object_fields?.linha || '-'),
                String(product.custom_object_fields?.familia_do_produto || product.custom_object_fields?.familia_produto || '-'),
                String(product.custom_object_fields?.codigo_erp || '-'),
                product.custom_object_fields?.ativo ? "Sim" : "Não",
                product.custom_object_fields?.peso ? `${product.custom_object_fields.peso} g` : '-',
                product.custom_object_fields?.altura ? `${product.custom_object_fields.altura} mm` : '-',
                product.custom_object_fields?.largura ? `${product.custom_object_fields.largura} mm` : '-',
                product.custom_object_fields?.profundidade ? `${product.custom_object_fields.profundidade} mm` : '-',
                product.quantidade.toString(),
                product.valorUnitario || 'Não informado'
              ]}
              defaultOpen={false}
            />
          ))}
        </div>
      )}
    </div>
  );
}
